export default "__VITE_ASSET__igKddrL5__"